import React, { useState } from 'react';

import OutsideClickHandler from 'react-outside-click-handler';

import Button from 'components/shared/Button';
import Input from 'components/shared/FormAdapters/FormDefault/Input';
import Loader from 'components/shared/Loader';
import MenuActionsHelper from 'components/shared/MenuActionsHelper';
import { useEscAction } from 'hooks/useEscAction';

import styles from './index.module.css';

const defaultTitle = 'What is the option title?';
const defaultPlaceholder = 'Option name...';

const COMPONENT_STATES = {
  INPUT: 'INPUT',
  CONFIRMATION: 'CONFIRMATION',
};

function CreateOption({
  onClose,
  initialValue = '',
  onCreateOption,
  title = defaultTitle,
  placeholder = defaultPlaceholder,
  withConfirmation = false,
  confirmationTitle = 'Would you like to create a page?',
}) {
  const [inputValue, setInputValue] = useState(initialValue);
  const [isLoading, setIsLoading] = useState(false);
  const [componentState, setComponentState] = useState(COMPONENT_STATES.INPUT);
  useEscAction(() => onClose());

  const handleCreateOption = async (optionName, confirmed) => {
    try {
      setIsLoading(true);
      await onCreateOption(optionName, confirmed);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetInputValue = () => {
    if (componentState === COMPONENT_STATES.INPUT) {
      if (!inputValue.trim()) return;

      if (withConfirmation) {
        setComponentState(COMPONENT_STATES.CONFIRMATION);
      } else {
        handleCreateOption(inputValue);
      }
    } else if (componentState === COMPONENT_STATES.CONFIRMATION) {
      handleCreateOption(inputValue, false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.charCode !== 13) {
      return;
    }
    if (componentState !== COMPONENT_STATES.INPUT) {
      return;
    }

    event.preventDefault();
    handleSetInputValue();
  };

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        if (inputValue.trim()) {
          handleSetInputValue();
        } else {
          onClose();
        }
      }}
    >
      <div className={styles.container}>
        {!isLoading && componentState === COMPONENT_STATES.INPUT && (
          <div className={styles.head}>
            <div className={styles.title}>{title}</div>
            <Input
              value={inputValue}
              autoFocus={true}
              placeholder={placeholder}
              onChange={(event) => setInputValue(event.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
        )}

        {!isLoading && componentState === COMPONENT_STATES.CONFIRMATION && (
          <div className={styles.head}>
            <div className={styles.title}>{confirmationTitle}</div>
            <div className={styles.actions}>
              <Button autoFocus type="default" onClick={() => handleCreateOption(inputValue, false)}>
                No
              </Button>
              <Button onClick={() => handleCreateOption(inputValue, true)}>Yes</Button>
            </div>
          </div>
        )}

        {isLoading && (
          <div className={styles.loaderContainer}>
            <Loader />
          </div>
        )}

        <MenuActionsHelper
          actions={[
            componentState === COMPONENT_STATES.INPUT && MenuActionsHelper.ACTION_TYPES.SELECT,
            MenuActionsHelper.ACTION_TYPES.ESCAPE,
          ].filter(Boolean)}
        />
      </div>
    </OutsideClickHandler>
  );
}

export default CreateOption;
